import CloseIcon from "@mui/icons-material/Close";
import { Dialog, Grid, IconButton } from "@mui/material";
import MuiDialogTitle from "@mui/material/DialogTitle";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import MyContext from "../../../contexts/MyContext";
import { AddReceipt } from "./AddReceipt";

export const AddAccommodationReceiptDialog = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);

  const handleSave = (receipt, totalCost) => {
    myContext.changeAccommodationReceipt(receipt);
    myContext.changeAccommodationTotalCost(totalCost);
    props.onClose();
  };

  return (
    <MyContext.Consumer>
      {(context) => (
        <Dialog fullScreen open={props.open} onClose={props.onClose}>
          <MuiDialogTitle>
            <IconButton aria-label="close" style={{ float: "right" }} onClick={props.onClose}>
              <CloseIcon />
            </IconButton>
          </MuiDialogTitle>
          <Grid container justifyContent="center" className="container custom">
            <Grid item>
              <strong>{t("add_receipt_for_expenses")}</strong>
              <p className="margin bottom-0">{t("add_all_receipts_for_accommodation")}</p>
              <p>
                <small>{t("max_25MB_per_file")}</small>
              </p>
              <AddReceipt totalCost={context.accommodationTotalCost} onSave={handleSave} receipt={context.accommodationReceipt} {...props} />
            </Grid>
          </Grid>
        </Dialog>
      )}
    </MyContext.Consumer>
  );
};
